import React, { Component, PropTypes } from 'react';
import get from 'lodash/get';
import ConfigurationCheckbox from '../../widgets/ConfigurationCheckbox';
import ReactSparkTextInput from '../../widgets/ReactSparkTextInput';
import ReactSparkSelectInput from '../../widgets/ReactSparkSelectInput';
import { childrenMaxAgeValue, calendarPriceDisplay } from '../../../constants/configurationListItems';
import Validator from '../../../utils/Validator';
import { configurationSystemDefault } from '../../../constants/SystemDefaults';
import If from '../../helpers/if';
import Message from '../../message/Message';

class SearchSettingsConfigurations extends Component {
    constructor(props) {
        super(props);
        this.sections = [];

        this.maxNumberOf = {
            adults: 19,
            children: 18,
            totalOccupancy: 37
        };
    }

    capitalize(word) {
        return word[0].toUpperCase() + word.slice(1);
    }

    arrivalLeadDaysConstraint(value, monthsOfInventory) {
        const { currentConfigCopy } = this.props;
        const inputValue = parseInt(value);

        if (inputValue >= 1) {
            return Math.min(
                inputValue,
                ((monthsOfInventory && this.monthsOfInventoryConstraint(monthsOfInventory)) ||
                    currentConfigCopy.monthsOfInventory) * 30,
                60
            );
        }
        return '';
    }

    monthsOfInventoryConstraint(value) {
        const inputValue = parseInt(value);

        if (isNaN(inputValue)) {
            return '';
        }
        return Math.max(Math.min(value, 36), 1);
    }

    maximumNumberOfNightsConstraint(value) {
        const inputValue = parseInt(value);

        if (isNaN(inputValue)) {
            return '';
        }
        return Math.max(Math.min(value, 365), 1);
    }

    render() {
        const { isDisabled, setConfigText, setConfigNumber, toggleConfigBoolean, currentConfigCopy } = this.props;

        const maximumNumberOfRooms = [
            { key: 0, label: 'No Limit' },
            { key: 1, label: '1' },
            { key: 2, label: '2' },
            { key: 3, label: '3' },
            { key: 4, label: '4' },
            { key: 5, label: '5' },
            { key: 6, label: '6' },
            { key: 7, label: '7' },
            { key: 8, label: '8' },
            { key: 9, label: '9' },
            { key: 10, label: '10' },
            { key: 15, label: '15' },
            { key: 20, label: '20' }
        ];

        return (
            <div className="spark-panel__content col-xs-12">
                <section className="row spark-panel__content">
                    <div className="col-xs-12">
                        <h3>Search Settings</h3>
                    </div>
                    <div className="col-xs-12 spark-margin-bottom">
                        <ConfigurationCheckbox
                            title="Show calendar legend"
                            isDisabled={isDisabled}
                            code="showCalendarLegend"
                            onChange={toggleConfigBoolean}
                            value={currentConfigCopy.showCalendarLegend}
                        />
                        <ReactSparkSelectInput
                            className="col-xs-12 col-md-4 spark-margin-bottom"
                            label="Calendar Price Display"
                            isDisabled={isDisabled}
                            defaultValue={currentConfigCopy.calendarPriceDisplay}
                            values={calendarPriceDisplay.map(v => {
                                return { key: v, label: v };
                            })}
                            onChange={event => {
                                setConfigText('calendarPriceDisplay', event.target.value);
                            }}
                        />
                        <ReactSparkTextInput
                            className="col-xs-12 col-md-4 spark-margin-bottom"
                            label="Default/Calendar Length of Stay (max 7)"
                            isDisabled={isDisabled}
                            value={currentConfigCopy.defaultLengthOfStay}
                            onChange={event => {
                                setConfigNumber('defaultLengthOfStay', event.target.value);
                            }}
                            onBlur={event => {
                                setConfigNumber('defaultLengthOfStay', Math.max(Math.min(event.target.value, 7), 1));
                            }}
                        />
                        <ReactSparkTextInput
                            className="col-xs-12 col-md-4 spark-margin-bottom"
                            label="Arrival Lead Days (+ days from shop date; max 60)"
                            isDisabled={isDisabled}
                            value={currentConfigCopy.arrivalLeadDays}
                            onChange={event => {
                                setConfigText('arrivalLeadDays', this.arrivalLeadDaysConstraint(event.target.value));
                            }}
                        />
                        <ReactSparkTextInput
                            className="col-xs-12 col-md-4 spark-margin-bottom"
                            label="Months of Inventory to display (1-36)"
                            isDisabled={isDisabled}
                            value={currentConfigCopy.monthsOfInventory}
                            onBlur={event => {
                                const value = event.target.value || configurationSystemDefault.monthsOfInventory;
                                setConfigNumber('monthsOfInventory', value);
                                setConfigText(
                                    'arrivalLeadDays',
                                    this.arrivalLeadDaysConstraint(currentConfigCopy.arrivalLeadDays, value)
                                );
                            }}
                            onChange={event => {
                                setConfigNumber(
                                    'monthsOfInventory',
                                    this.monthsOfInventoryConstraint(event.target.value)
                                );
                                setConfigText(
                                    'arrivalLeadDays',
                                    this.arrivalLeadDaysConstraint(
                                        currentConfigCopy.arrivalLeadDays,
                                        event.target.value
                                    )
                                );
                            }}
                        />
                        <ReactSparkTextInput
                            className="col-xs-12 col-md-4 spark-margin-bottom"
                            label="Max # of Nights Allowed to Book (1-365)"
                            isDisabled={isDisabled}
                            value={currentConfigCopy.maximumNumberOfNights}
                            onBlur={event => {
                                const value = event.target.value || configurationSystemDefault.maximumNumberOfNights;
                                setConfigText(
                                    'maximumNumberOfNights',
                                    this.maximumNumberOfNightsConstraint(
                                        value || configurationSystemDefault.maximumNumberOfNights
                                    )
                                );
                            }}
                            onChange={event => {
                                setConfigText(
                                    'maximumNumberOfNights',
                                    this.maximumNumberOfNightsConstraint(event.target.value)
                                );
                            }}
                        />
                    </div>
                    <div className="col-xs-12 spark-mar-l-1">
                        <h4>Guests (Occupancy)</h4>
                    </div>
                    <div className="col-xs-12 spark-margin-bottom">
                        <ReactSparkTextInput
                            className="col-xs-12 col-md-4 spark-margin-bottom"
                            label={`Max Number of Adults (1-${this.maxNumberOf.adults})`}
                            value={get(currentConfigCopy, 'adultMaxQuantity', this.maxNumberOf.adults)}
                            isDisabled={isDisabled}
                            onBlur={event => {
                                setConfigText(
                                    'adultMaxQuantity',
                                    Validator.validNumberInt(event.target.value, 1, this.maxNumberOf.adults)
                                );
                            }}
                            onChange={event => {
                                return setConfigText(
                                    'adultMaxQuantity',
                                    Validator.validNumberIntType(event.target.value)
                                );
                            }}
                        />
                        <ReactSparkTextInput
                            className="col-xs-12 col-md-4 spark-margin-bottom"
                            label={`Maximum Total Occupancy (Adults + Children) (1-${this.maxNumberOf.totalOccupancy})`}
                            value={get(currentConfigCopy, 'maxQuantityPerRoom', this.maxNumberOf.totalOccupancy)}
                            isDisabled={isDisabled}
                            onBlur={event => {
                                setConfigText(
                                    'maxQuantityPerRoom',
                                    Validator.validNumberInt(event.target.value, 1, this.maxNumberOf.totalOccupancy)
                                );
                            }}
                            onChange={event => {
                                setConfigText('maxQuantityPerRoom', Validator.validNumberIntType(event.target.value));
                            }}
                        />
                        <ConfigurationCheckbox
                            labelClassName="spark-mar-b-0"
                            title="Guest can specify children"
                            isDisabled={isDisabled}
                            code="disableChildrenSelection"
                            onChange={toggleConfigBoolean}
                            value={!currentConfigCopy.disableChildrenSelection}
                            inverse
                        />
                        <If condition={!currentConfigCopy.disableChildrenSelection}>
                            <div className="indent-left">
                                <ReactSparkTextInput
                                    className="col-xs-12 col-md-4 spark-margin-bottom"
                                    label={`Max Number of Children (0-${this.maxNumberOf.children})`}
                                    value={_.get(currentConfigCopy, 'childrenMaxQuantity', this.maxNumberOf.children)}
                                    isDisabled={isDisabled}
                                    onBlur={event => {
                                        setConfigText(
                                            'childrenMaxQuantity',
                                            Validator.validNumberInt(event.target.value, 0, this.maxNumberOf.children)
                                        );
                                    }}
                                    onChange={event => {
                                        setConfigText(
                                            'childrenMaxQuantity',
                                            Validator.validNumberIntType(event.target.value)
                                        );
                                    }}
                                />
                                <ReactSparkSelectInput
                                    className="col-xs-12 col-md-4 spark-margin-bottom"
                                    label="Max Age of Children"
                                    isDisabled={isDisabled}
                                    defaultValue={currentConfigCopy.childrenMaxAgeValue}
                                    values={childrenMaxAgeValue.map(v => {
                                        return { key: v, label: v };
                                    })}
                                    onChange={event => {
                                        setConfigNumber('childrenMaxAgeValue', event.target.value);
                                    }}
                                />
                                <ConfigurationCheckbox
                                    labelClassName="spark-mar-b-0"
                                    title="Collect child ages when children are selected"
                                    isDisabled={isDisabled}
                                    code="collectChildrenAge"
                                    onChange={toggleConfigBoolean}
                                    value={currentConfigCopy.collectChildrenAge}
                                />
                                <If condition={currentConfigCopy.collectChildrenAge}>
                                    <div className="indent-left">
                                        <Message
                                            heading="The booking engine will automatically ask for child ages if CR option for child age ranges is set up."
                                            body={`"Guest can specify children" option should be unchecked to fully exclude child pricing and availability.`}
                                            noBorder
                                            noBackground
                                            panelClassName="spark-mar-l-1"
                                            messagePanelClassName="spark-pad-0"
                                            type="warning"
                                        />
                                    </div>
                                </If>
                            </div>
                        </If>
                    </div>
                    <div className="col-xs-12 spark-mar-l-1">
                        <h4>Multi-room Settings</h4>
                    </div>
                    <div className="col-xs-12 spark-margin-bottom">
                        <div className="col-xs-12 col-md-4 spark-margin-bottom">
                            <ReactSparkSelectInput
                                label="Maximum Number of Rooms per Itinerary"
                                isDisabled={this.props.isDisabled}
                                defaultValue={this.props.currentConfigCopy.maximumNumberOfRoomsPerItinerary}
                                values={maximumNumberOfRooms.map(v => ({ key: v.key, label: v.label }))}
                                onChange={event => {
                                    const obj = maximumNumberOfRooms.find(elem => {
                                        return elem.key === parseInt(event.target.value);
                                    });
                                    this.props.setConfigText('maximumNumberOfRoomsPerItinerary', obj.key);
                                }}
                            />
                        </div>

                        <ConfigurationCheckbox
                            title="Allow guests to select multiple rooms as part of their occupancy options"
                            isDisabled={isDisabled}
                            code="enableMultiRoomFlow"
                            onChange={toggleConfigBoolean}
                            value={currentConfigCopy.enableMultiRoomFlow}
                        />
                    </div>
                </section>
            </div>
        );
    }
}

SearchSettingsConfigurations.propTypes = {
    currentConfigCopy: PropTypes.shape({
        arrivalLeadDays: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        calendarPriceDisplay: PropTypes.string,
        childrenMaxAgeValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        collectChildrenAge: PropTypes.bool,
        disableChildrenSelection: PropTypes.bool,
        maximumNumberOfNights: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        monthsOfInventory: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        showCalendarLegend: PropTypes.bool
    }).isRequired,
    isDisabled: PropTypes.bool.isRequired,
    setConfigText: PropTypes.func.isRequired,
    toggleConfigBoolean: PropTypes.func.isRequired
};

export default SearchSettingsConfigurations;



// WEBPACK FOOTER //
// ./src/components/pages/pages/SearchSettingsConfigurations.js